<div class="modal-header">
  <h3 class="modal-title fkm-modal-title" id="modal-title">{{data.namn}}</h3>
  <button type="button" id="btnKundDetailClose" class="btn-close" (click)="dismiss()"></button>
</div>
@if (initialized) {
  <div class="modal-body">
    <div class="row">
      <rask-textmultiline aid="ckleverantorhuvudkod" class="col-3" label="Huvudkod" [value]="ckLeverantorDetails.huvudkod" [tightLabel]="true" ></rask-textmultiline>
      <rask-textmultiline aid="ckleverantorinternnummer" class="col-3" label="Internnummer" [value]="ckLeverantorDetails.internnummer" [tightLabel]="true"></rask-textmultiline>
      <rask-textmultiline aid="ckleverantortelefon" class="col-3" label="Telefon" [value]="ckLeverantorDetails.telefon" [tightLabel]="true"></rask-textmultiline>
      <rask-checkbox
        aid="ckleverantordoldkund"
        class="col-3"
        text="Dölj"
        label="Dölj i leverantörsorder"
        [(ngModel)]="data.doljForLeverantorsorder"
        (ngModelChange)="onDoldChange($event)"
        [disabled]="disableDoljCKLeverantor()"
      infoText="Leverantör döljs i leverantörsorder. Leverantör kan endast döljas om den saknar kopplade leverantörer samt att leverantören inte är kopplad till någon leverantörsorder."></rask-checkbox>
    </div>
    @if (data.doljForLeverantorsorder) {
      <div class="row">
        <rask-selector
          aid="ckleverantorforalderKund"
          label="Koppla till"
          [values]="ckLeverantorDetails.valbaraForaldraCkLeverantorer"
          [viewFormatter]="ckLeverantorFormatter"
          [formatter]="idFormatter"
          [(ngModel)]="data.parentCKLeverantorId"
        (ngModelChange)="onChange()"></rask-selector>
      </div>
    }
    @if (!data.doljForLeverantorsorder) {
      <div class="row">
        <rask-textmultiline aid="ckleverantorkoppladekunderlista" class="col-12" label="Kopplad till" [value]="koppladeCkLeverantorer" [tightLabel]="true"></rask-textmultiline>
      </div>
    }
    <div class="row">
      <rask-textmultiline aid="ckleverantoruppdaterad" class="col-4" label="Uppdaterad" [value]="ckLeverantorDetails.uppdaterad" [tightLabel]="true"></rask-textmultiline>
      <rask-textmultiline aid="ckleverantorlimeId" class="col-4" label="Lime Id" [value]="ckLeverantorDetails.limeId" [tightLabel]="true"></rask-textmultiline>
      <rask-textmultiline aid="ckleverantorstatusILime" class="col-4" label="Status i Lime" [value]="ckLeverantorDetails.statusILime" [tightLabel]="true"></rask-textmultiline>
    </div>
    <div class="row">
      <rask-textmultiline aid="ckleverantororgNummer" class="col-4" label="Organisationsnummer" [value]="ckLeverantorDetails.orgNummer" [tightLabel]="true"></rask-textmultiline>
      <rask-textmultiline aid="ckleverantoravtalsansvarig" class="col-4" label="Avtalsansvarig" [value]="ckLeverantorDetails.avtalsansvarig" [tightLabel]="true"></rask-textmultiline>
      <rask-textmultiline aid="ckleverantoravdelning" class="col-4" label="Avdelning" [value]="ckLeverantorDetails.avdelning" [tightLabel]="true"></rask-textmultiline>
    </div>
    <div class="row">
      <rask-textmultiline aid="ckleverantorbesoksadress" class="col-4" label="Besöksadress" [values]="ckLeverantorDetails.besoksadress" [tightLabel]="true"></rask-textmultiline>
      <rask-textmultiline aid="ckleverantorpostadress" class="col-4" label="Postadress" [values]="ckLeverantorDetails.postadress" [tightLabel]="true"></rask-textmultiline>
      <rask-textmultiline aid="ckleverantorlandOchLandskod" class="col-4 land-text" label="Land och landskod" [value]="ckLeverantorDetails.landOchLandskod" [tightLabel]="true"></rask-textmultiline>
    </div>
  </div>
}

<div class="modal-footer">
  <rask-save-button aid="ckleverantorbuttonDetailRadSave" (click)="save()" [disabled]="!canSave()">
  </rask-save-button>
</div>
